<div class="overlay" [class.visible]="uiService.isSingleRoomControlOverlayOpen$ | async">
  <div class="overlay-container">
    <div class="overlay-header flex flex-row justify-between items-start">
      <h1>
        {{
          activeSrcOverlay === singleRoomControlOverlayTypeEnum.SingleRoomControlVdzForm
            ? ('+INSTALLATIONS.SRC.VDZ_FORM.TITLE' | translate)
            : ('+INSTALLATIONS.SRC.SINGLE_ROOM_CONTROL' | translate)
        }}
      </h1>
      <!-- Desktop view -->
      <div class="lt-md:!inline-flex">
        <button
          *ngIf="
            activeSrcOverlay === singleRoomControlOverlayTypeEnum.SingleRoomControlCommissioning ||
            activeSrcOverlay === singleRoomControlOverlayTypeEnum.SingleRoomControlSettings ||
            activeSrcOverlay === singleRoomControlOverlayTypeEnum.SingleRoomControlVdzForm
          "
          data-at-close-overlay-btn
          mat-stroked-button
          (click)="back()"
          class="back-btn-overlay lt-md:!hidden"
          gtm="onBack"
          gtmAction="Back to SRC details overlay"
          gtmCategory="srcDetails"
        >
          <mat-icon>arrow_back</mat-icon>
          <span>{{ '+INSTALLATIONS.INSTALLATION.OVERLAY.BACK_BUTTON' | translate }}</span>
        </button>
        <button
          data-at-close-overlay-btn
          mat-stroked-button
          (click)="close()"
          class="close-btn-overlay lt-md:!hidden"
          gtm="onClose"
          gtmAction="Installation details overlay"
          gtmCategory="installationDetails"
        >
          <span>{{ '+INSTALLATIONS.INSTALLATION.OVERLAY.CLOSE_BUTTON' | translate }}</span>
          <mat-icon iconPositionEnd>close</mat-icon>
        </button>
        <!-- Mobile view -->
        <button
          *ngIf="
            activeSrcOverlay === singleRoomControlOverlayTypeEnum.SingleRoomControlCommissioning ||
            activeSrcOverlay === singleRoomControlOverlayTypeEnum.SingleRoomControlSettings ||
            activeSrcOverlay === singleRoomControlOverlayTypeEnum.SingleRoomControlVdzForm
          "
          mat-icon-button
          (click)="back()"
          class="back-btn-small !hidden lt-md:!inline-flex"
          gtm="onBack"
          gtmAction="Back to SRC details overlay"
          gtmCategory="srcDetails"
        >
          <mat-icon>arrow_back</mat-icon>
        </button>
        <button
          mat-icon-button
          (click)="close()"
          class="close-btn-small !hidden lt-md:!inline-flex"
          gtm="onClose"
          gtmAction="Installation details overlay"
          gtmCategory="installationDetails"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <ng-container [ngSwitch]="activeSrcOverlay">
      <app-src-details-overlay
        *ngSwitchCase="singleRoomControlOverlayTypeEnum.SingleRoomControlDetails"
        [installationId]="installationId"
        [gatewaySerial]="gatewaySerial"
      ></app-src-details-overlay>
      <app-src-commissioning-overlay
        *ngSwitchCase="singleRoomControlOverlayTypeEnum.SingleRoomControlCommissioning"
        [gatewaySerial]="gatewaySerial"
      ></app-src-commissioning-overlay>
      <app-src-settings-overlay
        *ngSwitchCase="singleRoomControlOverlayTypeEnum.SingleRoomControlSettings"
        [gatewaySerial]="gatewaySerial"
      ></app-src-settings-overlay>
      <app-src-vdz-form-overlay
        *ngSwitchCase="singleRoomControlOverlayTypeEnum.SingleRoomControlVdzForm"
      ></app-src-vdz-form-overlay>
    </ng-container>
  </div>
</div>
